//put requests/routes in this urlArray to skip them from encrypting bcoz in below the Content-Type here is multipart/form-data

export const urlArray = [
  '/tenantsReports/',
  'sadmin/paymentDetails/',
  '/internetProfile/',
  '/emailkyc',
  '/research',
  '/setting/agreement',
  '/research/researchData',
  '/refresh',
  '/compareKycDetails',
  '/download-zip',
  // Add more URLs as needed
];
